(() => {
  if (window.AllegroLockCardsInitialized) return;
  window.AllegroLockCardsInitialized = true;

  const CARD_ROOT_SELECTOR = "[data-alg-lock-cards]";
  const CARD_SELECTOR = "[data-lock-value]";

  const PRODUCT_ROOT_SELECTOR = [
    "product-information",
    "featured-product-information",
    ".product-information",
    ".product",
    "section[id*='product']",
    "[data-product-id]"
  ].join(",");

  const normalize = (value) =>
    String(value || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/\s+/g, " ")
      .trim()
      .toLowerCase();

  const escapeCss = (value) => {
    if (window.CSS && typeof window.CSS.escape === "function") {
      return window.CSS.escape(value);
    }

    return String(value).replace(/["\\]/g, "\\$&");
  };

  const getCards = (cardsRoot) =>
    Array.from(cardsRoot.querySelectorAll(CARD_SELECTOR));

  const getProductRoot = (element) =>
    element.closest(PRODUCT_ROOT_SELECTOR) ||
    element.closest("section") ||
    element.parentElement;

  const getSearchScopes = (cardsRoot) => {
    const scopes = [];
    const closestForm = cardsRoot.closest("form");
    const productRoot = getProductRoot(cardsRoot);

    if (closestForm) {
      scopes.push(closestForm);
    }

    if (productRoot && !scopes.includes(productRoot)) {
      scopes.push(productRoot);
    }

    return scopes;
  };

  const updateCards = (cardsRoot, selectedValue) => {
    if (!cardsRoot || !cardsRoot.isConnected) return;

    const wanted = normalize(selectedValue);

    getCards(cardsRoot).forEach((card) => {
      const isSelected =
        normalize(card.dataset.lockValue) === wanted;

      card.classList.toggle("is-selected", isSelected);

      card.setAttribute(
        "aria-pressed",
        isSelected ? "true" : "false"
      );
    });
  };

  const findMatchingRadio = (cardsRoot, requestedValue) => {
    for (const scope of getSearchScopes(cardsRoot)) {
      const radios = Array.from(
        scope.querySelectorAll('input[type="radio"]')
      );

      const match = radios.find(
        (radio) =>
          normalize(radio.value) === normalize(requestedValue)
      );

      if (match) return match;
    }

    return null;
  };

  const findMatchingSelect = (cardsRoot, requestedValue) => {
    const wanted = normalize(requestedValue);

    for (const scope of getSearchScopes(cardsRoot)) {
      const selects = scope.querySelectorAll("select");

      for (const select of selects) {
        const option = Array.from(select.options).find(
          (item) =>
            normalize(item.value) === wanted ||
            normalize(item.textContent) === wanted
        );

        if (option) {
          return {
            select,
            option
          };
        }
      }
    }

    return null;
  };

  const getRadioLabel = (radio) => {
    if (!radio) return null;

    const wrappedLabel = radio.closest("label");

    if (wrappedLabel) {
      return wrappedLabel;
    }

    if (!radio.id) return null;

    return document.querySelector(
      `label[for="${escapeCss(radio.id)}"]`
    );
  };

  const syncCardsRoot = (cardsRoot) => {
    if (!cardsRoot || !cardsRoot.isConnected) return;

    const cards = getCards(cardsRoot);

    if (!cards.length) return;

    for (const scope of getSearchScopes(cardsRoot)) {
      const checkedRadios = Array.from(
        scope.querySelectorAll(
          'input[type="radio"]:checked'
        )
      );

      const selectedRadio = checkedRadios.find(
        (radio) =>
          cards.some(
            (card) =>
              normalize(card.dataset.lockValue) ===
              normalize(radio.value)
          )
      );

      if (selectedRadio) {
        updateCards(cardsRoot, selectedRadio.value);
        return;
      }
    }

    for (const scope of getSearchScopes(cardsRoot)) {
      const selects = scope.querySelectorAll("select");

      for (const select of selects) {
        const matchingCard = cards.find(
          (card) =>
            normalize(card.dataset.lockValue) ===
            normalize(select.value)
        );

        if (matchingCard) {
          updateCards(cardsRoot, select.value);
          return;
        }
      }
    }
  };

  const selectLockVariant = (card) => {
    const cardsRoot = card.closest(CARD_ROOT_SELECTOR);

    if (!cardsRoot) return;

    const requestedValue = card.dataset.lockValue;

    if (!requestedValue) return;

    updateCards(cardsRoot, requestedValue);

    const matchingRadio = findMatchingRadio(
      cardsRoot,
      requestedValue
    );

    if (matchingRadio) {
      if (!matchingRadio.checked) {
        const label = getRadioLabel(matchingRadio);

        if (label) {
          label.click();
        } else {
          matchingRadio.click();
        }
      }

      window.setTimeout(
        () => syncCardsRoot(cardsRoot),
        50
      );

      window.setTimeout(
        () => syncCardsRoot(cardsRoot),
        250
      );

      return;
    }

    const matchingSelect = findMatchingSelect(
      cardsRoot,
      requestedValue
    );

    if (matchingSelect) {
      matchingSelect.select.value =
        matchingSelect.option.value;

      matchingSelect.select.dispatchEvent(
        new Event("input", {
          bubbles: true
        })
      );

      matchingSelect.select.dispatchEvent(
        new Event("change", {
          bubbles: true
        })
      );

      window.setTimeout(
        () => syncCardsRoot(cardsRoot),
        50
      );

      window.setTimeout(
        () => syncCardsRoot(cardsRoot),
        250
      );

      return;
    }

    console.warn(
      `Allegro Chain: "${requestedValue}" için eşleşen Shopify kilit varyantı bulunamadı.`
    );
  };

  const addScopedStyles = () => {
    if (
      document.getElementById(
        "allegro-lock-cards-css"
      )
    ) {
      return;
    }

    const style = document.createElement("style");

    style.id = "allegro-lock-cards-css";

    style.textContent = `
      .alg-lock-enabled fieldset:has(input[type="radio"][value$="Lock"]):not([data-alg-lock-cards]),
      .alg-lock-enabled variant-option:has(input[type="radio"][value$="Lock"]):not([data-alg-lock-cards]),
      .alg-lock-enabled .variant-option:has(input[type="radio"][value$="Lock"]):not([data-alg-lock-cards]),
      .alg-lock-enabled .product-form__input:has(input[type="radio"][value$="Lock"]):not([data-alg-lock-cards]),
      .alg-lock-enabled .product-form__option:has(input[type="radio"][value$="Lock"]):not([data-alg-lock-cards]),
      .alg-lock-enabled fieldset:has(select option[value$="Lock"]):not([data-alg-lock-cards]),
      .alg-lock-enabled .product-form__input:has(select option[value$="Lock"]):not([data-alg-lock-cards]) {
        display: none !important;
      }

      [data-alg-lock-cards] {
        display: block !important;
      }

      [data-alg-lock-cards] [data-lock-value] {
        cursor: pointer;
        pointer-events: auto;
      }
    `;

    document.head.appendChild(style);
  };

  const observedProductRoots = new WeakMap();

  const observeCardsRoot = (cardsRoot) => {
    const productRoot = getProductRoot(cardsRoot);

    if (!productRoot) return;

    productRoot.classList.add("alg-lock-enabled");

    if (observedProductRoots.has(productRoot)) {
      return;
    }

    let timer;

    const observer = new MutationObserver((mutations) => {
      const relevantMutation = mutations.some(
        (mutation) =>
          Array.from(mutation.addedNodes).some((node) => {
            if (!(node instanceof Element)) {
              return false;
            }

            return (
              node.matches?.(
                `${CARD_ROOT_SELECTOR}, input[type="radio"], select, variant-option, variant-selects`
              ) ||
              node.querySelector?.(
                `${CARD_ROOT_SELECTOR}, input[type="radio"], select, variant-option, variant-selects`
              )
            );
          })
      );

      if (!relevantMutation) return;

      window.clearTimeout(timer);

      timer = window.setTimeout(() => {
        productRoot
          .querySelectorAll(CARD_ROOT_SELECTOR)
          .forEach(syncCardsRoot);
      }, 40);
    });

    observer.observe(productRoot, {
      childList: true,
      subtree: true
    });

    observedProductRoots.set(
      productRoot,
      observer
    );
  };

  const initialize = (scope = document) => {
    addScopedStyles();

    scope
      .querySelectorAll(CARD_ROOT_SELECTOR)
      .forEach((cardsRoot) => {
        observeCardsRoot(cardsRoot);
        syncCardsRoot(cardsRoot);

        window.setTimeout(
          () => syncCardsRoot(cardsRoot),
          100
        );

        window.setTimeout(
          () => syncCardsRoot(cardsRoot),
          350
        );
      });
  };

  document.addEventListener(
    "click",
    (event) => {
      const card = event.target.closest(
        `${CARD_ROOT_SELECTOR} ${CARD_SELECTOR}`
      );

      if (!card) return;

      event.preventDefault();
      event.stopPropagation();

      selectLockVariant(card);
    }
  );

  document.addEventListener(
    "change",
    (event) => {
      const target = event.target;

      if (
        !(
          target instanceof HTMLInputElement ||
          target instanceof HTMLSelectElement
        )
      ) {
        return;
      }

      const productRoot = target.closest(
        ".alg-lock-enabled"
      );

      if (!productRoot) return;

      window.setTimeout(() => {
        productRoot
          .querySelectorAll(CARD_ROOT_SELECTOR)
          .forEach(syncCardsRoot);
      }, 0);

      window.setTimeout(() => {
        productRoot
          .querySelectorAll(CARD_ROOT_SELECTOR)
          .forEach(syncCardsRoot);
      }, 150);
    }
  );

  document.addEventListener(
    "DOMContentLoaded",
    () => initialize(document)
  );

  document.addEventListener(
    "shopify:section:load",
    (event) => initialize(event.target)
  );

  document.addEventListener(
    "shopify:block:select",
    (event) => initialize(event.target)
  );

  if (document.readyState !== "loading") {
    initialize(document);
  }
})();